import React from "react";
import { Box, Button } from "@mui/material";

function InternationalTransferFooterButtons({ 
    handleButtonOne, 
    handleButtonTwo, 
    handleMiddleButton,
    handlePrintReceipt, 
    buttonOneText, 
    buttonTwoText, 
    middleButtonText,
    showButtonOne = true, 
    showButtonTwo = true,
    showMiddleButton = false,
    showPrintReceipt = false, 
    disableButtonOne = false,
    disableButtonTwo = false,
    disableMiddleButton = false,
}) {

    return (
        <Box
            display="flex"
            justifyContent="space-around"
            className="mt-4">
            {showButtonOne &&
                <Button
                    className="fs-size-12 paiy-blue text-white py-3 px-5"
                    onClick={handleButtonOne}
                    disabled={disableButtonOne}>
                    {buttonOneText}
                </Button>
            }
            {
                showMiddleButton && 
                <Button
                    className="fs-size-12 paiy-green text-white rounded py-3 px-5"
                    onClick={handleMiddleButton}
                    disabled={disableMiddleButton}>
                    {middleButtonText}
                </Button>
            }
            {showPrintReceipt &&               
                <Button
                    className="fs-size-12 paiy-blue text-white rounded py-3 px-5"
                    onClick={handlePrintReceipt}>
                    Print Receipt
                </Button>
            }
            {showButtonTwo &&
                <Button
                    className="fs-size-12 paiy-green text-white rounded py-3 px-5"
                    onClick={handleButtonTwo}
                    disabled={disableButtonTwo}>
                    {buttonTwoText}
                </Button>
            }

        </Box>
    )
}

export default InternationalTransferFooterButtons;